<mat-toolbar class="navbar" color="secondary">
  <router-outlet name="full-navbar-heading"></router-outlet>

  <span class="mc-fill-remaining-flex-space"></span>

  <router-outlet name="app-navbar-launch-pad"></router-outlet>
</mat-toolbar>
